import { httpClient } from '../httpClient';
export class DataChargeRepository {
    // データチャージ
    async dataCharge(params) {
        const { data } = await httpClient.post(`data-charge/request`, JSON.stringify(({ chargeCapacity: params.chargeCapacity } = params)));
    }
    // データチャージ履歴
    async getDataChargeHistory(params) {
        const { data } = await httpClient.get(`data-charge/history/fetch`);
        return data;
    }
}
